import axios from 'axios'
import store from '../store/index'
import Storage from '../utils/storage'
import { message } from 'ant-design-vue'

export const getToken = ()=> {return store.state.token}

const http = axios.create({
  // baseURL: '/api',
  method: 'post',
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  },
})

http.interceptors.request.use(
  (config)=>{
    config.headers = {
      ...config.headers,
    }
    return config
  },
  (error) => {
    message.error('请求超时:', error.toString())
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      if (!response.data.success) {
        message.error(response.data.message)
        if(response.data.message === 'Invalid token.') {
          Storage.clear('token')
          window.location.href = '/login'
        }
      }
    }
    return response
  },
  (error) => {
    message.error('请求超时:', error.toString())
    return Promise.reject(error)
  }
)

export default http;